import { LogOut } from 'lucide-react'
import { BrandLogo } from '@components/ui'
import { TestimonialsSection } from '@components/marketing/TestimonialsSection'
import { PricingContactActions } from '@components/pricing/PricingContactActions'
import { PricingPlansSection } from '@components/pricing/PricingPlansSection'
import { useAuthStore } from '@store/useAuthStore'

export function TrialExpiredPage() {
  const { user, logout } = useAuthStore()

  return (
    <div className="min-h-screen overflow-x-hidden bg-secondary-50">
      <header className="border-b border-secondary-200 bg-[#17253C] px-4 py-4 sm:px-6">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4">
          <BrandLogo className="h-10 max-h-10 sm:h-12 sm:max-h-12" />
          <button
            type="button"
            onClick={() => logout()}
            className="inline-flex items-center gap-2 rounded-lg border border-white/20 px-3 py-2 text-sm font-medium text-white transition hover:bg-white/10"
          >
            <LogOut className="h-4 w-4" aria-hidden strokeWidth={2} />
            Sair
          </button>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-8 sm:px-6 sm:py-12">
        <div className="mb-4 text-center sm:mb-5">
          <h1 className="text-2xl font-bold text-secondary-900 sm:text-3xl">
            O seu período experimental terminou
          </h1>
          <p className="mx-auto mt-3 max-w-2xl text-secondary-600">
            {user?.name ? `${user.name}, ` : ''}
            para continuar a usar o FIXDAUTO escolha um dos planos abaixo ou fale connosco — a nossa equipa ajuda na
            ativação e na migração dos seus dados.
          </p>
        </div>

        <PricingPlansSection
          showTrialBanner={false}
          showSignupCtas={false}
          showSectionHeading={false}
          compactSpacing
          className="rounded-3xl bg-white px-4 py-4 shadow-sm sm:px-8 sm:py-5"
        />

        <div className="mt-8 flex justify-center rounded-3xl bg-white px-4 py-8 shadow-sm sm:px-8 sm:py-10">
          <PricingContactActions title="Entre em contacto connosco" />
        </div>
      </main>

      <TestimonialsSection title="O que dizem sobre nós" />
    </div>
  )
}
